var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{class:_vm.className,style:({ backgroundColor: _vm.backgroundColor }),attrs:{"icon":_vm.iconName?'el-icon-' + _vm.iconName:''},on:{"click":function($event){return _vm.hanldClick()}}},[_vm._t("svgImg"),_vm._v(" "+_vm._s(_vm.text)+"\n  ")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02dfd4c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vbutton/index.vue
// module id = null
// module chunks = 